import { render, staticRenderFns } from "./DepartamentsPermissions.vue?vue&type=template&id=0a1b8edc"
import script from "./DepartamentsPermissions.vue?vue&type=script&lang=js"
export * from "./DepartamentsPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports